module.exports = __webpack_public_path__ + "img/index_3.02862cd1.png";